import { Star } from "lucide-react";
import { ScrollReveal, SectionLabel } from "./Reveal";

const testimonials = [
  { quote: "Jacques didn't just film our shop, he made us look like a brand. Bookings jumped the week the film went live.", name: "Marcus Bell", role: "Owner · Northface Barbers" },
  { quote: "Our reservations doubled inside a month. The film is everything our website tried to say and never quite did.", name: "Sofia Alvarez", role: "GM · Rico's Kitchen" },
  { quote: "We hire a lot of creatives. Jacques was the only one who cared more about the story than the shot list.", name: "James Whitmore", role: "Marketing Director · Ashton Hotels" },
  { quote: "New sign-ups tripled the fortnight after the launch reel dropped. Members were tagging the film themselves.", name: "Priya Shah", role: "Founder · Iron & Oak Gym" },
  { quote: "The look completely repositioned us. Retailers finally treat us like a premium brand and pricing followed.", name: "Kwame Osei", role: "Creative Director · Halcyon Apparel" },
  { quote: "I watched my own story back and had to sit down. That's the only review I need to give.", name: "Amara Okafor", role: "Distance Runner" },
];

export const TestimonialsSection = () => (
  <section data-testid="testimonials-section" className="py-24 lg:py-32">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <SectionLabel index="04" title="Kind Words" />
        <h2 className="font-display leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
          What clients say.
        </h2>
      </ScrollReveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {testimonials.map((t, i) => (
          <ScrollReveal key={t.name} delay={(i % 3) * 0.08} className="h-full">
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="bg-[#0A0A0A] hover:bg-[#111111] p-8 lg:p-10 h-full flex flex-col transition-colors duration-500"
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-[#F2F0EB] text-[#F2F0EB]" />
                ))}
              </div>
              <blockquote className="mt-6 text-base text-[#F2F0EB]/90 leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-sm tracking-[0.05em]">{t.name}</div>
                <div className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#8A8A85] mt-1.5">{t.role}</div>
              </figcaption>
            </figure>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);
